module.exports = __webpack_public_path__ + "images/empty.698dbae0.png";